import { createFileRoute } from "@tanstack/react-router";
import AdminContactDetailPage from "@/admin/pages/contact-detail";

export const Route = createFileRoute("/admin/contacts/$id")({
  component: AdminContactDetailPage,
});
